export default "__VITE_ASSET__CP$fUkNM__"